import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "bubble-annotation-3, message" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M9.99998 17.9168C14.3722 17.9168 17.9166 14.3724 17.9166 10.0002C17.9166 5.62791 14.3722 2.0835 9.99998 2.0835C5.62773 2.0835 2.08331 5.62791 2.08331 10.0002C2.08331 11.2563 2.37586 12.4441 2.89654 13.4991C2.93871 13.5846 2.95249 13.6815 2.93334 13.7748L2.20795 17.3095C2.14845 17.5994 2.40179 17.8572 2.69274 17.8028L6.34433 17.1196C6.43332 17.1029 6.52515 17.116 6.60693 17.1549C7.6353 17.6435 8.78572 17.9168 9.99998 17.9168Z",
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }),
      _createElementVNode("path", {
        id: "vector_2",
        d: "M5.70831 10.0002C5.70831 10.2993 5.95083 10.5418 6.24998 10.5418C6.54913 10.5418 6.79165 10.2993 6.79165 10.0002C6.79165 9.70101 6.54913 9.4585 6.24998 9.4585C5.95083 9.4585 5.70831 9.70101 5.70831 10.0002ZM9.45831 10.0002C9.45831 10.2993 9.70083 10.5418 9.99998 10.5418C10.2991 10.5418 10.5416 10.2993 10.5416 10.0002C10.5416 9.70101 10.2991 9.4585 9.99998 9.4585C9.70083 9.4585 9.45831 9.70101 9.45831 10.0002ZM13.2083 10.0002C13.2083 10.2993 13.4508 10.5418 13.75 10.5418C14.0491 10.5418 14.2916 10.2993 14.2916 10.0002C14.2916 9.70101 14.0491 9.4585 13.75 9.4585C13.4508 9.4585 13.2083 9.70101 13.2083 10.0002Z",
        fill: "currentColor",
        stroke: "currentColor",
        "stroke-width": "0.25",
        "stroke-linecap": "square"
      })
    ], -1)
  ])))
}
export default { render: render }